"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _canUseDOM = _interopRequireDefault(require("../utils/canUseDOM"));

var _getElement = require("../utils/getElement");

var _isEmptyObject = _interopRequireDefault(require("../utils/isEmptyObject"));

var _Scrollix = _interopRequireDefault(require("./Scrollix"));
/*!
 * VERSION: 0.0.1
 * DATE: 2018-06-08
 * UPDATES AND DOCS AT: TBD
 *
 *
 * @author: Matthew Rumery, matthew@rumery.io
 */

/* eslint-disable no-underscore-dangle, react/no-this-in-sfc */


class GSAPAnimations extends _Scrollix.default {
  constructor(options) {
    var _this;

    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    super(options);
    _this = this;
    (0, _defineProperty2.default)(this, "_onLoad", () => {
      if (!(0, _isEmptyObject.default)(this._targetTween)) {
        this._targetTween.pause();
      }

      if (this._scrollBased) {
        this.handleEventListeners('add', 'scroll', this.scrollEvent);
      }
    });
    (0, _defineProperty2.default)(this, "resetTween", function () {
      let reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this._targetTween && reset) {
        _this._targetTween.restart();

        _this._targetTween.paused(reset);
      }
    });
    (0, _defineProperty2.default)(this, "updateTweenProgress", () => {
      if (this._targetTween && this._scrollBased) {
        if (this._targetElement) {
          const progress = (0, _getElement.getElementProgress)(this._targetElement, this._reverse);

          if (-1 !== progress) {
            this._targetTween.progress(progress);
          } else {
            this._targetTween.pause();
          }
        } else {
          this._targetTween.play();
        }
      }
    });
    (0, _defineProperty2.default)(this, "destroy", () => {
      this.handleEventListeners('remove', 'scroll', this.scrollEvent);

      if (!(0, _isEmptyObject.default)(this._targetTween)) {
        this._targetTween.kill();
      }
    });
    (0, _defineProperty2.default)(this, "handleEventListeners", (listener, type, event) => {
      if (_canUseDOM.default) {
        window[`${listener}EventListener`](type, event, 'add' === listener ? false : '');
      }
    });
    (0, _defineProperty2.default)(this, "scrollEvent", () => {
      if (this._timeout) {
        window.cancelAnimationFrame(this._timeout);
      }

      this._timeout = window.requestAnimationFrame(() => this.updateTweenProgress());
      return this._timeout;
    });
    (0, _defineProperty2.default)(this, "getScrollDirection", element => {
      if (_canUseDOM.default) {
        const position = (0, _getElement.getElementPosition)(element);

        if (position.y > this._prevScrollPosition) {
          this._scrollPosition = 'DOWN';
        } else if (this._prevScrollPosition > position.y) {
          this._scrollPosition = 'UP';
        }

        this._prevScrollPosition = position.y;
        return this._scrollPosition;
      }

      return null;
    });
    this._reverse = options.reverse;
    this._duration = options.duration;
    this._callback = callback;
    /* class values */

    this._scrollPosition = 'INITIAL';
    this._prevScrollPosition = 0;
    this._timeout = undefined;
    this._prevRatio = 0;

    this._onLoad();
  }

}

var _default = GSAPAnimations;
exports.default = _default;